export default __webpack_public_path__ + "static/media/service_section_bg.f8999a35.jpg";